export async function wait_ms(time_ms: number): Promise<void> {
  return new Promise<void>((sleep) => setTimeout(() => sleep(), time_ms));
}
